<ul *ngIf="type?.name === 'marked'">
  <li *ngFor="let item of items">{{item}}</li>
</ul>
<ol *ngIf="type?.name === 'numeric'">
  <li *ngFor="let item of items">{{item}}</li>
</ol>
